/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { TemplateRead } from "../../models/template-read";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadTemplates$Params {
  organisation_id: string;

  /**
   * The sort will accept parameters like `col` or `col:desc` and will split on the `:`. If it does not find a `:` it will sort ascending on that column. Sortable columns: id, name, comment
   */
  sort?: Array<string> | null;
  name?: string | null;
  offset?: number;
  limit?: number;
}

export function readTemplates(
  http: HttpClient,
  rootUrl: string,
  params: ReadTemplates$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<TemplateRead>>> {
  const rb = new RequestBuilder(rootUrl, readTemplates.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.query("sort", params.sort, {});
    rb.query("name", params.name, {});
    rb.query("offset", params.offset, {});
    rb.query("limit", params.limit, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TemplateRead>>;
    }),
  );
}

readTemplates.PATH = "/surfdomeinen/organisations/{organisation_id}/templates/";
